(() => {
  document.addEventListener('change', event => {
    if (event.target.matches('[data-m3d-colour-filter]')) location.assign(event.target.value);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('.m3d-card-colours button');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const row = button.closest('.m3d-card-colours');
    if (button.matches('.m3d-card-colour-more')) {
      row.querySelectorAll('[hidden]').forEach(el => el.hidden = false);
      button.setAttribute('aria-expanded','true'); button.hidden = true; return;
    }
    row.dataset.chosen = 'true';
    const card = button.closest('product-card');
    if (!card) return;
    row.querySelectorAll('.m3d-card-colour').forEach(el => el.setAttribute('aria-pressed',String(el === button)));
    row.querySelector('.m3d-card-colour-name').textContent = button.dataset.colour;
    card.querySelectorAll('a[href*="/products/"]').forEach(a => {const url=new URL(a.href);url.searchParams.set('variant',button.dataset.variant);a.href=url.href;});
    if (button.dataset.image) {
      const url = new URL(button.dataset.image,location.origin); url.searchParams.set('width','700');
      card.querySelectorAll('[ref="cardGallery"] img, .card-gallery img').forEach(img => {img.removeAttribute('srcset');img.src=url.href;img.alt=button.dataset.colour;});
      card.setAttribute('data-featured-media-url',url.href);
    }
  },true);
  function selectFilteredColour() {
    const family=decodeURIComponent(location.pathname).match(/color-([a-z]+)/)?.[1];
    if (!family) return;
    document.querySelectorAll('.m3d-card-colours:not([data-chosen])').forEach(row => {
      const button=[...row.querySelectorAll('[data-families]')].find(b => b.dataset.families.split(',').includes(family));
      if (button) {button.hidden=false;button.click();}
    });
  }
  selectFilteredColour();
  new MutationObserver(selectFilteredColour).observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
})();
